var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { HeaderBlock } from '../components/HeaderBlock';
import { ButtonsBlock } from '../components/ButtonsBlock';
import { CountBlock } from '../components/CountBlock';
export var HomeworkEdit = function (_a) {
    var text = _a.text, types = _a.types, count = _a.count, onToggleType = _a.onToggleType, rest = __rest(_a, ["text", "types", "count", "onToggleType"]);
    return (React.createElement(React.Fragment, null,
        React.createElement(HeaderBlock, __assign({ text: text }, rest)),
        React.createElement(ButtonsBlock, { selectedTypes: types, onToggleType: onToggleType }),
        React.createElement(CountBlock, __assign({ count: count, types: types }, rest))));
};
//# sourceMappingURL=HomeworkEdit.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { HeaderBlock } from '../components/HeaderBlock';
import { ButtonsBlock } from '../components/ButtonsBlock';
import { CountBlock } from '../components/CountBlock';
export var HomeworkEdit = function (_a) {
    var text = _a.text, types = _a.types, count = _a.count, onToggleType = _a.onToggleType, rest = __rest(_a, ["text", "types", "count", "onToggleType"]);
    return (React.createElement(React.Fragment, null,
        React.createElement(HeaderBlock, __assign({ text: text }, rest)),
        React.createElement(ButtonsBlock, { selectedTypes: types, onToggleType: onToggleType }),
        React.createElement(CountBlock, __assign({ count: count, types: types }, rest))));
};
//# sourceMappingURL=HomeworkEdit.js.map